import { Heart, Search, ShoppingBag } from "lucide-react";

export default function Nav({ onCheckout }) {
  return (
    <nav
      data-testid="main-nav"
      className="absolute inset-x-0 top-0 z-20 flex items-center justify-between px-6 py-7 md:px-12"
    >
      <div className="flex items-center gap-8 font-mono text-[11px] tracking-[0.35em] text-cream/90">
        <a data-testid="nav-link-shop" href="#shop" className="transition-colors hover:text-white">
          SHOP
        </a>
        <a data-testid="nav-link-about" href="#about" className="transition-colors hover:text-white">
          ABOUT
        </a>
        <a data-testid="nav-link-lookbook" href="#lookbook" className="transition-colors hover:text-white">
          LOOKBOOK
        </a>
      </div>
      <div className="flex items-center gap-6 text-cream/90">
        <button type="button" aria-label="Search" data-testid="nav-search" className="transition-colors hover:text-white">
          <Search size={17} strokeWidth={1.5} />
        </button>
        <button type="button" aria-label="Wishlist" data-testid="nav-wishlist" className="transition-colors hover:text-white">
          <Heart size={17} strokeWidth={1.5} />
        </button>
        <button
          type="button"
          aria-label="Bag"
          data-testid="nav-bag"
          onClick={onCheckout}
          className="flex items-center gap-2 transition-colors hover:text-white"
        >
          <ShoppingBag size={17} strokeWidth={1.5} />
          <span className="font-mono text-[10px]">0</span>
        </button>
      </div>
    </nav>
  );
}
